import styled from 'styled-components';

export const CellContent = styled.div`
  margin: 0;
  padding: 15px 0;

  svg {
    cursor: pointer;
    padding: 5px;
    height: 30px;
    width: 30px;
  }

  svg.add {
    stroke: #40608f;
  }

  svg.delete {
    color: var(--color-link);
  }
`;
